module.exports = __webpack_public_path__ + "static/media/women-preview.015024ff.jpg";